import * as z from "zod";
import { userFacingError } from "../authorization";
import { MAIN_BRANCH_NAME } from "../branchName";
import { mutator } from "./mutator";

const volumeDataSchema = z.object({
  volumeName: z.string(),
  // A file or directory within the volume; the whole volume when omitted.
  path: z.string().min(1).optional(),
});

export const deleteLiveVolumeDataSchema = volumeDataSchema.extend({
  spaceId: z.string(),
});

export const deleteBranchVolumeDataSchema = volumeDataSchema.extend({
  branchId: z.string(),
});

export const deletePersonalVolumeDataSchema = volumeDataSchema;

export const deleteLiveVolumeData = mutator({
  schema: deleteLiveVolumeDataSchema,
  resolve: {
    space: { kind: "space", from: "spaceId" },
  },
  permissions: [
    { permission: "space:write", scopeId: ({ args }) => args.space.id },
    // Clearing live data changes what the live version runs against.
    { permission: "space:push_live", scopeId: ({ args }) => args.space.id },
  ],
  description:
    "Deletes a file, folder, or all stored data from a space’s live volume.",
  interactionType: "delete",
  fn: async () => {},
});

export const deleteBranchVolumeData = mutator({
  schema: deleteBranchVolumeDataSchema,
  resolve: {
    branch: { kind: "branch", from: "branchId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.branch.workflow.spaceId,
    },
  ],
  description:
    "Deletes a file, folder, or all stored data from a draft branch’s volume.",
  interactionType: "delete",
  fn: async ({ args }) => {
    // The live branch’s volume is the space’s live volume, which needs push_live.
    if (args.branch.name === MAIN_BRANCH_NAME) {
      throw userFacingError("Delete live data from the space instead.");
    }
  },
});

export const deletePersonalVolumeData = mutator({
  schema: deletePersonalVolumeDataSchema,
  resolve: {},
  permissions: {
    none: "personal volumes are resolved only for ctx.userId",
  },
  description:
    "Deletes a file, folder, or all stored data from the caller’s chat volume.",
  interactionType: "delete",
  fn: async () => {},
});
